import axios from 'axios'
import { Notify } from 'vant'
import apiObj from '@a/js/api.js'

// create an axios instance
const service = axios.create({
  // baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // baseURL: 'http://v0.api.upyun.com',
  baseURL: apiObj.VUE_APP_UPYUN_API,
  // withCredentials: true, // send cookies when cross-domain requests
  // timeout: 5000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  (config) => {
    // do something before request is sent
    return config
  },
  (error) => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  (response) => {
    const res = response.data

    // if the custom code is not 20000, it is judged as an error.
    if (res.code !== 200) {
      Notify({
        type: 'danger',
        message: '文件上传失败！',
      })
      return Promise.reject(new Error(res.msg || 'Error'))
    } else {
      return res
    }
  },
  (error) => {
    if (error && error.response) {
      switch (error.response.status) {
        case 400:
          Notify({
            type: 'danger',
            message: '请求错误 - 400',
          })
          break
        case 401:
          Notify({
            type: 'danger',
            message: '未授权，请重新登录 - 401',
          })
          break
        case 403:
          Notify({
            type: 'danger',
            message: '拒绝访问 - 403',
          })
          break
        case 404:
          Notify({
            type: 'danger',
            message: '请求出错 - 404',
          })
          break
        case 408:
          Notify({
            type: 'danger',
            message: '请求超时 - 408',
          })
          break
        case 500:
          Notify({
            type: 'danger',
            message: '服务端响应 - 500',
          })
          break
        case 501:
          Notify({
            type: 'danger',
            message: '服务未实现 - 501',
          })
          break
        case 502:
          Notify({
            type: 'danger',
            message: '网络错误 - 502',
          })
          break
        case 503:
          Notify({
            type: 'danger',
            message: '服务不可用 - 503',
          })
          break
        case 504:
          Notify({
            type: 'danger',
            message: '网络超时 - 504',
          })
          break
        case 505:
          Notify({
            type: 'danger',
            message: 'HTTP版本不受支持 - 505',
          })
          break
        default:
          Notify({
            type: 'danger',
            message: `连接出错 - ${error.response.status}!`,
          })
      }
    } else {
      Notify({
        type: 'danger',
        message: '连接服务器失败！',
      })
    }
    return Promise.reject(error)
  }
)

export default service
